const defaultPruneFn = property => property !== null && property !== undefined;

/**
 * Remove
 * @param obj
 * @param pruneFn
 * @returns {string[]|*}
 */
export const pruneObject = (obj, pruneFn = defaultPruneFn) => {
  if (Array.isArray(obj)) return obj.filter(p => pruneFn(p));

  return Object.keys(obj).reduce((result, key) => {
    if (pruneFn(obj[key])) {
      return { ...result, [key]: obj[key] };
    }

    return result;
  }, {});
};
